import { BetterStackEvent, CustomBetterStackEvent } from './types';

export const createPayload = (
    event: CustomBetterStackEvent,
    origin: string | undefined,
): BetterStackEvent => {
    const { level, data, ...rest } = event;

    const message = {
        ...rest,
        data: {
            ...data,
            origin,
        },
    };

    return {
        level,
        message: JSON.stringify(message),
        dt: Date.now().toString(),
    };
};
